import { isEmptyValue } from '../../../utils/managerUtils';
import { createFlattenedFormItemsArray } from './createFlattenedFormItemsArray';

export const findFirstEmptyMandatoryField = (
  formData: Record<string, any>,
  formItems: any[],
  isMounted?: (name: string) => boolean
): string | undefined => {
  const flattenedFormItems = createFlattenedFormItemsArray(formItems);

  const firstEmptyMandatory = flattenedFormItems.find(
    (item) =>
      item.visible &&
      item.mandatory &&
      isEmptyValue(formData[item.name]) &&
      (!isMounted || isMounted(item.name))
  );

  return firstEmptyMandatory?.name;
};
